var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StyledStatusBar',[_c('div',{staticClass:"status-bar"},[_c('div',{staticClass:"status-bar__label"},[_vm._v(_vm._s(_vm.$t(_vm.statusBar.label)))]),_c('div',{staticClass:"status-bar__step"},[_vm._v(_vm._s(_vm.$t('step', { step: _vm.statusBar.step, steCnt: 4 })))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }